import { render } from "./drafts.vue?vue&type=template&id=0db60e95&scoped=true"
import script from "./drafts.vue?vue&type=script&lang=js"
export * from "./drafts.vue?vue&type=script&lang=js"

import "./drafts.vue?vue&type=style&index=0&id=0db60e95&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db60e95"]])

export default __exports__